import { landingExploreCards } from './landingExploreContent'

// One reviewed clip per portrait, shared across Discover, Explore and the hero.
export const landingMotionVideos = Object.fromEntries(
  landingExploreCards.map((card) => [
    card.id,
    card.imageUrl
      .replace('/landing-explore-v2/', '/landing-feed-motion-v1/')
      .replace(/\.webp$/, '.mp4'),
  ]),
)

const exploreVideoIds = new Set([
  'landing-marina-blonde',
  'landing-sunset-sport-anime',
  'landing-midnight-rooftop-v2',
  'landing-boardwalk-blonde-v2',
  'landing-blue-top-night-market-v2',
])

export const landingExploreFeed = landingExploreCards.map((card) => ({
  ...card,
  // These are new sample creations, not records with community engagement.
  // An unspecified image model gets Card's neutral AI badge and style label.
  model: '',
  likes: 0,
  views: 0,
  ...(exploreVideoIds.has(card.id)
    ? {
        video: true,
        imageUrl: landingMotionVideos[card.id],
        videoThumbnail: card.imageUrl,
        original_image_url: card.imageUrl,
        videoVersion: 5, // The clips use the same LTX 2.3 engine as Video v4-voice.
        audio_enabled: false,
      }
    : {}),
}))
